import { Component, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { takeUntil, Subject, combineLatest } from 'rxjs';

import type { Attachment } from '@recruitee/attachments-types';
import { SpinnerComponent } from '@recruitee/user-interface';

import { RequisitionsFilesContainerComponent } from '../../../containers/single-requisition/requisitions-files-container/requisitions-files-container.component';
import { FilesPageDataService } from '../../../data/single-requisition/files-page-data.service';

@Component({
  selector: 'rt-requisitions-files-page',
  templateUrl: './files-page.component.html',
  standalone: true,
  imports: [SpinnerComponent, RequisitionsFilesContainerComponent],
  providers: [FilesPageDataService],
})
export class FilesPageComponent {
  public attachments: Attachment[];
  public requisitionId: number;
  public isLoaded: boolean;

  private ngOnDestroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private data: FilesPageDataService,
  ) {}

  public ngOnInit(): void {
    combineLatest([this.data.attachments$, this.data.requisition$, this.data.isLoaded$])
      .pipe(takeUntil(this.ngOnDestroy$))
      .subscribe(([attachments, requisition, isLoaded]) => {
        this.attachments = attachments;
        this.requisitionId = requisition.id;
        this.isLoaded = isLoaded;
        this.cdRef.detectChanges();
      });
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
